import FormHandler from '../forms/FormHandler';
import IFormPostHandler, { FormPostResult } from '../forms/IFormPostHandler';
import ValidationService, { ValidationResult } from '../forms/ValidationService';
import UserFacingIdentifiers from '../shared/UserFacingIdentifiers';
import IPaymentProvider from './IPaymentProvider';
import PaymentProviderErrors from './PaymentProviderErrors';

export class CheckoutFormPostHandler implements IFormPostHandler {
  constructor(private formHandler: FormHandler, private paymentProvider?: IPaymentProvider) { }

  async post(): Promise<FormPostResult> {
    const formData = this.formHandler.formDataRetriever.getFormData();
    const results = await ValidationService.validateForm(formData);

    const paymentProviderValidation = this.validatePaymentProvider();
    if (paymentProviderValidation !== null) {
      results.validationResults.push(paymentProviderValidation);
    }

    results.isValid = results.validationResults.every((x) => x.isValid);
    return { validationResult: results };
  }

  private validatePaymentProvider(): ValidationResult | null {
    if (!this.paymentProvider) { return null; }

    const { isValid } = this.paymentProvider;
    const fieldId = UserFacingIdentifiers.paymentSubmitHeading;
    const message = isValid ? '' : PaymentProviderErrors.TN_CREDITCARD_TYPE_MISMATCH_EXCEPTION;
    return { fieldId, isValid, message };
  }
}
